<template>
    <div :class="$attrs.class" class="terms-container">
        <h3>{{ lang($t("terms_title")) }}</h3>

        <div class="content-box">
            <p v-html="lang($t('terms_intro'), { current_website: currentWebsite() })"></p>
            <p v-html="lang($t('terms_revision_notice'))"></p>

            <div>
                <h4>{{ lang($t('terms_definitions.title')) }}</h4>
                <p v-if="$t('terms_definitions.subtitle')">{{ lang($t('terms_definitions.subtitle')) }}</p>
                <ol>
                    <li v-for="(line, index) in $t('terms_definitions.content')" :key="index" v-html="lang(line, { current_website: currentWebsite() })"></li>
                </ol>
            </div>

            <div>
                <h4>{{ lang($t('account_registration.title')) }}</h4>
                <p v-for="(line, index) in $t('account_registration.content')" :key="index" v-html="line"></p>
            </div>


            <div>
                <h4>{{ lang($t('online_conduct.title')) }}</h4>
                <p>{{ lang($t('online_conduct.subtitle'))}}</p>
                <ol>
                    <li v-for="(line, index) in $t('online_conduct.content')" :key="index" v-html="line"></li>
                </ol>
                <p>{{ lang($t('complaint_intro'))}}</p>
                <ol>
                    <li v-for="(line, index) in $t('complaint_intro_content')" :key="index" v-html="line"></li>
                </ol>
                <div v-for="(line, index) in $t('complaint_disclaimer')" :key="index">
                    <p>{{ line }}</p>
                </div>
            </div>

            <div>
                <h4>{{ lang($t('termination_title'))}}</h4>
                <p>{{ lang($t('termination_content'))}}</p>
            </div>

            <div>
                <h4>{{ lang($t('intellectual_property.title'))}}</h4>
                <ul>
                    <li v-for="(section, index) in lang($t('intellectual_property.sections'))" :key="index">
                        <strong>{{ section.title }}</strong>
                        <p v-if="section.subtitle">{{ section.subtitle }}</p>
                        <div v-for="(item, i) in section.content" :key="i">
                            <p v-if="typeof item === 'string'">{{ item }}</p>
                            <ol v-else-if="item.list_type === 'ol'">
                                <li v-for="(li, j) in item.items" :key="j">{{ li }}</li>
                            </ol>
                            <ul v-else-if="item.list_type === 'ul'">
                                <li v-for="(li, j) in item.items" :key="j">{{ li }}</li>
                            </ul>
                        </div>
                    </li>
                </ul>
            </div>

            <div>
                <h4>{{ lang($t('data_privacy.title')) }}</h4>
                <p v-for="(line, index) in $t('data_privacy.content')" :key="index">{{ line }}</p>
            </div>

            <div>
                <h4>{{ lang($t('applicable_law.title')) }}</h4>
                <p v-for="(line, index) in $t('applicable_law.content')" :key="index">{{ line }}</p>
            </div>

            <div>
                <h4>{{ lang($t('general_terms.title')) }}</h4>
                <ol>
                    <li v-for="(line, index) in $t('general_terms.content')" :key="index" v-html="line"></li>
                </ol>
            </div>

            <div>
                <h4>{{ lang($t('complete_agreement.title')) }}</h4>
                <p v-for="(line, index) in $t('complete_agreement.content')" :key="index">{{ line }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import {common} from '@js/mixins/common'
export default {
    name: "TermsContent",
    mixins: [common],
    inheritAttrs: false,
    methods: {
        currentWebsite() {
            let url = "http://" + window.location.host;
            if (window.location.protocol === "https:") {
                url = "https://" + window.location.host;
            }
            return `<a class="txt-link" href="${url}">${url}</a>`;
        }
    }
};
</script>

<style scoped>
.terms-container {
    line-height: 1.6;
    font-size: 16px;
    color: #333;
}

.terms-container h3{
    margin-bottom: 20px !important;
}

.terms-container h4 {
    margin-top: 1.5em;
    margin-bottom: 0.5em;
}

.terms-container p {
    margin-bottom: 1em;
}

.terms-container ol,
.terms-container ul {
    margin: 0 0 1em 1.5em;
}

.terms-container li {
    margin-bottom: 0.5em;
}

.content-box > div {
    margin-bottom: 2em;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/TermsContent.vue